<template>
  <div class="forgetPwd">
    <Header
      :title="title"
      :right-content="rightContent"
    />
    <div id="content">
      <div class="layout">
        <form>
          <div>
            <div class="input-box">
              <div class="item">
                <span>账号</span>
                <input
                  v-model="login.customerNumber"
                  class="input-item width"
                  placeholder="请输入账号"
                  type="number"
                  oninput="if(value.length>8)value=value.slice(0,8);value=value.replace(/[^\d]/g,'')"
                >
                <i v-if="customerType!=''">{{ customerType }}</i>
              </div>
            </div>
            <div
              v-if="customerType!=''"
              class="input-box"
            >
              <div class="item">
                <span>手机号</span>
                <em>{{ mobileAccount }}</em>
              </div>
            </div>
          </div>
          <div class="input-box">
            <div class="item">
              <span>新密码</span>
              <input
                v-model="login.password"
                class="input-item"
                :type="[showPwd?'text':'password']"
                minlength="8"
                maxlength="16"
                placeholder="请输入密码"
                @blur="passwordBlur"
              >
            </div>
            <img
              v-if="showPwd"
              class="icon"
              src="@/assets/images/login/open-code.png"
              alt=""
              @click="togglePwd()"
            >
            <img
              v-else
              class="icon"
              src="@/assets/images/login/close-code.png"
              alt=""
              @click="togglePwd()"
            >
          </div>
          <VerifyCode
            :code="login.code"
            :phone="rightPhone"
            :account-number="login.customerNumber"
            :this-page-type="pageType"
            :code-type="codeType"
            @changeCode="changeCode"
          />
        </form>
        <div class="forgetPwd-tips">
          新密码必须满足以下要求：
          <ul>
            <li>1. 密码长度需要8至16位字符。</li>
            <li>2. 密码必须包含四种字符类型：小写字母、大写字母、数字和特殊字符（只限-_.~四种字符）。</li>
          </ul>
        </div>
        <div class="btnItem">
          <p class="errMessage">{{ this.errMessage }}</p>
          <p class="chat">账号找回有问题，请通过 <a @click="changePhone">手机号找回?</a> 或 <a @click="openLive800">联系客服</a></p>
          <span
            class="submit addSuc"
            @click="forgetPwd"
          >找回密码</span>
          <p>温馨提示：若真实账号与模拟账号有绑定关系，将统一修改真实与模拟账号的密码；修改密码同时适用于账号下所有交易平台。</p>
        </div>
      </div>
    </div>
    <!--修改密码成功-->
    <div
      v-if="sucPop"
      class="popFixed"
    >
      <div class="masking" />
      <div class="tcCon">
        <div class="item">
          <p>密码已设置成功，3s后自动返回登录</p>
        </div>
        <div class="btnCon only">
          <span @click="goLogin">去登录({{ count }}s)</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
require('@/assets/css/forgetPwd.css')
import Header from '@/view/module/Header.vue'
import VerifyCode from '@/view/module/VerifyCode.vue'
import api from '@/plugins/api'
import { mapState } from 'vuex'
export default {
  name: 'ForgetPwdAcc',
  components: { Header, VerifyCode },
  computed: {
    ...mapState(['pageType']),
    loginParam: {
      get() {
        return {
          accountNo: this.login.customerNumber,
          password: this.login.password,
          code: this.login.code
        }
      }
    }
  },
  data() {
    return {
      title: '忘记密码',
      showPwd: false,
      login: {
        customerNumber: '',
        mobilePhone: '',
        password: '',
        code: ''
      },
      errMessage: '',
      sucPop: false,
      count: '',
      timer: '',
      codeType: 'RESET_CUSTOMER_PWD',
      rightContent: 'isNo',
      mobileAccount: '',
      customerType: '',
      rightPhone: '',
      rightCustomer: ''
    }
  },
  watch: {
    login: {
      deep: true,
      handler(newValue, oldValue) {
        if (!newValue.customerNumber) this.errMessage = ''
        if (!String(newValue.customerNumber).startsWith('1') && !String(newValue.customerNumber).startsWith('8') && newValue.customerNumber.length == 8) this.errMessage = '请输入正确的交易账号'
        // if (newValue.customerNumber != '' && newValue.password == '') {
        //   if (newValue.customerNumber.length == 8 && (String(newValue.customerNumber).startsWith('1') || String(newValue.customerNumber).startsWith('8'))) this.autoGetAccountNo(newValue.customerNumber);
        //   else {
        //     this.rightCustomer = "";
        //     this.customerType = ''
        //   }
        // }
      }
    }
  },
  mounted() {
    this.$bus.$emit('loading', true)
  },
  destroyed() {
    clearInterval(this.timer)
  },
  activated() {
    this.$bus.$emit('loading', true)
  },
  methods: {
    passwordBlur(e) {
      const Regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[-_.~{};':"\\|,.<>\/?])[A-Za-z\d-_.~{};':"\\|,.<>\/?]{8,16}$/;
      if (!Regex.test(this.login.password)) {
        this.errMessage = '请输入符合规则密码';
        console.log(this.errMessage); // 输出错误信息
      } else {
        this.errMessage = ''; // 清空错误信息
      }
    },
    openLive800() {
      var url = `https://onlinecs.cffx139.net/Web/im.aspx?_=t&accountid=137707&visitorid=${new Date().getTime()}`
      var left = (screen.width / 2) - (600 / 2)
      var top = (screen.height / 2) - (400 / 2)
      window.open(url,
        'DescriptiveWindowName',
        'resizable,scrollbars=yes,status=1,width=800, height=550, top=' + top + ', left=' + left)
    },
    togglePwd() {
      this.showPwd = !this.showPwd
    },
    changeCode(code) {
      this.login.code = code
    },
    // autoGetAccountNo (number) {
    //   if (number.length == 8) {
    //     api.getCustomerInfoByAccountNo(number).then(res => {
    //       if (res.data.code == 200) {
    //         this.errMessage = "";
    //         this.customerType = res.data.data.userType;
    //         this.mobileAccount = res.data.data.mobileAccount;
    //         this.rightCustomer = this.login.customerNumber
    //       } else {
    //         this.errMessage = res.data.code_desc;
    //         this.rightCustomer = ""
    //       }
    //     })
    //   }
    // },
    forgetPwd() {
      const Regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[-_.~{};':"\\|,.<>\/?])[A-Za-z\d-_.~{};':"\\|,.<>\/?]{8,16}$/
      const readyData = this.$qs.stringify(this.loginParam)
      if (this.login.customerNumber.length == 8 && this.login.password.length >=8 && this.login.code.length == 6) {
        if (Regex.test(this.login.password) == false) this.errMessage = '请输入8-16位字母数字特殊字符组合密码'
        else {
          api.forgetPwd(readyData).then(res => {
            if (res.data.code == 200) {
              this.errMessage = ''
              this.sucPop = true
              this.countDown()
            } else this.errMessage = res.data.code_desc
          })
        }
      }
    },
    goLogin() {
      this.$bus.$emit('loading', false)
      localStorage.clear()
      this.$store.dispatch('setUser', {})
      this.$store.dispatch('setTokenCookie', {})
      if (this.$route.query.pageType) this.$store.dispatch('setPageType', this.$route.query.pageType)
      this.sucPop = false
      if (!this.sucPop) clearInterval(this.timer)
      if (this.pageType == 'app') window.location.href = 'https://gologin'
      else window.location.href = process.env.VUE_APP_PATH + 'login'
    },
    countDown() {
      const time = 3
      if (this.sucPop) {
        this.count = time
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= time) {
            this.count--
          } else {
            this.goLogin()
          }
        }, 1000)
      } else clearInterval(this.timer)
    },
    changePhone() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/forgetPwd' })
    }
  }
}
</script>
